import { of as observableOf, Observable, map } from 'rxjs';
import { Injectable, inject } from '@angular/core';

import { HisBackendService } from '../backend/his-backend.service';
import { HisUiService } from './his-ui.service';
import { GenericValue } from '../../model/generic-value';

@Injectable({providedIn: 'root'})
export class HisGenericValueService {
    private hisUiService = inject(HisUiService);
    private backendService = inject(HisBackendService);


    private booleanValues: GenericValue[] = null;

    constructor() {
        this.booleanValues = new Array<GenericValue>();
        this.booleanValues.push( { id: 1, text: this.hisUiService.translate( 'de.his.javang.ja.lowercase' ), objGuid: '1' } );
        this.booleanValues.push( { id: 0, text: this.hisUiService.translate( 'de.his.javang.nein.lowercase' ), objGuid: '0' } );
    }

    /**
     * @return an array containing GenericValues for 'yes' and 'no'
     */
    getBooleanTypes(): GenericValue[] {
        return this.booleanValues;
    }

    isValidBeanName( beanName: string ): Observable<boolean> {
        return this.backendService.getData( `api/v1/cs/sys/values/check/${beanName}` ).pipe( map( result => result === true ) );
    }

    /**
     * get all values/entries for given entity (key table values)
     *
     * @param entity of key table
     */
    getValueTypes( entity: string ): Observable<GenericValue[]> {
        return this.backendService.getData( `api/v1/cs/sys/values/${entity}` );
    }

    /**
     * get values/entries by text of given entity (key table values)
     *
     * @param entity of key table
     * @param query search text
     */
    filterValueTypes( entity: string, query: string ): Observable<GenericValue[]> {
        return this.backendService.getData( `api/v1/cs/sys/values/${entity}?q=${encodeURI(query)}` );
    }

    // TODO sgr: Sollten wir das nicht in eine andere Util-Klasse verlagern?
    // Das ist ja kein Service!?
    findRowByValue( array: any[], value: number ): any {
        if ( array ) {
            let row = {} as GenericValue;
            for ( row of array ) {
                if ( row.id === value ) {
                    return row;
                }
            }
        }
        return null;
    }

    // TODO sgr: Sollten wir das nicht in eine andere Util-Klasse verlagern?
    // Das ist ja kein Service!?
    deleteRow( array: any[], i: number ): any[] {
        let updatedArray = [];
        if ( array ) {
            let rowIndex = 0;
            for ( let row of array ) {
                if ( rowIndex !== i ) {
                    updatedArray.push( row );
                }
                rowIndex++;
            }
        }
        return updatedArray;
    }
}
